// apps/sms-enrollment/src/components/EasyStep.tsx
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Badge } from 'foundations-library/components'
import { getVerbalColors } from 'helpers'

interface EasyStepProps {
  title: string
  subtitle: string
  badge: string
  // placeholder for later (url / class / whatever you decide)
  img?: string
}

const useStyles = makeStyles((theme: any) => {
    const { colors } = theme['foundations-library'] || {}
    const verbalColors = getVerbalColors(colors)

    return {
        root: {
            width: '290px',
            height: '330px',
            display: 'flex',
            flexDirection: 'column',
            border: `1px solid ${verbalColors['neutral-100']}`,
            borderRadius: '10px',
            padding: '20px'
        },
        image: {
            width: '250px',
            minHeight: '163px',
            borderRadius: '20px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        },
        title: {
            marginTop: '20px'
        },
        subtitle: {
            marginTop: '15px',
            color: '#364047'
        },
        badgeWrap: {
            marginTop: '5px'
        },
        badge: {
            padding: '0px 7px !important'
        }
    }
})

/**
 *
 */
const EasyStep: React.FC<EasyStepProps> = ({ title, subtitle, badge, img }) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.image} style={img ? { backgroundImage: `url(${img})` } : undefined} />

            <Typography className={classes.title} variant='subtitle1' color='neutral-900'>
                {title}
            </Typography>

            <Typography className={classes.subtitle} variant='body1'>
                {subtitle}
            </Typography>

            <div className={classes.badgeWrap}>
                <Badge size='small' color='primary' className={classes.badge}>
                    {badge}
                </Badge>
            </div>
        </div>
    )
}

export default EasyStep
